<div class="wrapper">

    <!-- Preloader -->
    <!-- <div class="preloader flex-column justify-content-center align-items-center">
      <img class="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60">
    </div> -->

    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand navbar-white navbar-light">
      <div class="navbar-nav w-100 d-flex align-items-center">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
        </li>
        <div class="flex-grow-1 d-flex justify-content-center"  style="margin-left: -60px;">
          <img src="assets/dmk.png" style="width: 50px; height: auto;" alt="MyRoots Logo">
        </div>
      </div>   
    </nav>
    <!-- /.navbar -->

    <!-- Main Sidebar Container -->
    <aside class="main-sidebar sidebar-primary elevation-4" style="position: fixed;">
        <!-- Brand Logo -->
        <!-- <a style="display: inline-flex;padding-top: 10px;
        padding-left: 80px;color:#015792;">
          <img src="assets/dmk.png" alt="AdminLTE Logo" class="img-circle elevation-2" style="opacity: .8;width:40px;height:40px;">
          <span class="brand-text " style="margin-left: 10px;margin-top:15px;"></span>
        </a> -->
        <a style="display: flex; align-items: center; padding: 10px 20px; color:#015792;">
          <img src="assets/dmk.png" alt="Admin Logo" style="width: 40px; height: auto;">
          <span class="brand-text" style="margin-left: 15px; font-weight: bold; font-size: 18px;">MENTOR</span>
        </a>

        <!-- Sidebar -->
        <div class="sidebar" style="height: calc(100vh - 85px); overflow-y: auto;">
            <!-- Sidebar user panel (optional) -->
            <!-- <div class="user-panel mt-3 d-flex"> -->
                <!-- <div class="image">
                    <img src="assets/user-icon.png" class="img-circle elevation-2" alt="User Image">
                </div> -->
                <!-- <div class="">
                    <a class="d-block newcolor">MENTOR</a>
                </div> -->
            <!-- </div> -->

            <!-- SidebarSearch Form -->
            <!-- <div class="form-inline">
          <div class="input-group" data-widget="sidebar-search">
            <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
            <div class="input-group-append">
              <button class="btn btn-sidebar">
                <i class="fas fa-search fa-fw"></i>
              </button>
            </div>
          </div>
        </div> -->

            <!-- Sidebar Menu -->
            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu"
                    data-accordion="false" style="height:100%;">
                    <li class="nav-item">
                        <a [routerLink]="['mtdashboard']" class="nav-link" data-widget="pushmenu">
                            <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                              <path fill="black"
                                d="M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1" />
                            </svg></i>
                            <p style="margin-left: 8px;color:black" >
                                Dashboard
                            </p>
                        </a>
                    </li>
                    <li class="nav-item">
                      <div class="nav-link" (click)="show()" style="cursor: pointer;">
                        <i class="fas fa-book">
                          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                            <path fill="black" d="M4 6H2v16h16v-2H4zm18-4H6v16h16zm-3 9H9V9h10zm-4 4H9v-2h6zm4-8H9V5h10z" />
                          </svg> -->
                        </i>
                        <p style="margin-left: 8px; color: black;">Course</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" [style.transform]="showCourse ? 'rotate(180deg)' : 'rotate(0deg)'"
                             [style.transition]="'transform 0.3s ease'" style="margin-left: auto;">
                          <path fill="black" d="M7 10l5 5 5-5z"/>
                        </svg>
                      </div>
                    
                     
                      <ul *ngIf="showCourse">
                        <li class="nav-item">
                          <a [routerLink]="['mentorstudentgrouprequest']" class="nav-link" data-widget="pushmenu">
                            <i class="fas fa-user-graduate" style="color: #000; font-weight: 900; font-size: 15px;"></i>
                            <!-- <i class="fas fa-file-alt" style="color: #000; font-weight: 900; font-size: 15px;"></i> -->
                            <!-- <i class="bi bi-person-lines-fill"></i> -->
                            <!-- <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
                              <path fill="black"
                                d="M19.95 15.89c.18.08.37.11.55.11c.41 0 .81-.17 1.1-.48L23.94 13H27c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3h-8c-1.65 0-3 1.35-3 3v4.99c0 1.65 1.35 3 3 3v1.5c0 .63.37 1.17.95 1.4M10.5 18c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m0 11.99c-2.9 0-5.12-.8-6.62-2.368c-1.931-2.015-1.886-4.585-1.881-4.838v-.017C2 21.26 3.26 20 4.82 20h11.36c1.55 0 2.82 1.259 2.82 2.817v.01c.004.182.06 2.77-1.88 4.805C15.62 29.201 13.4 30 10.5 30z" />
                            </svg></i> -->
                            <p style="margin-left: 8px;color:#000;">
                              Student Course Request
                            </p>
                          </a>
                        </li>
                    <li class="nav-item">
                      <a [routerLink]="['mentorcourselist']" class="nav-link" data-widget="pushmenu">
                        <i class="fas fa-file-alt"style="color: #000; font-weight: 900; font-size: 15px;"></i>
                          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
                          <path fill="black"
                            d="M19.95 15.89c.18.08.37.11.55.11c.41 0 .81-.17 1.1-.48L23.94 13H27c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3h-8c-1.65 0-3 1.35-3 3v4.99c0 1.65 1.35 3 3 3v1.5c0 .63.37 1.17.95 1.4M10.5 18c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m0 11.99c-2.9 0-5.12-.8-6.62-2.368c-1.931-2.015-1.886-4.585-1.881-4.838v-.017C2 21.26 3.26 20 4.82 20h11.36c1.55 0 2.82 1.259 2.82 2.817v.01c.004.182.06 2.77-1.88 4.805C15.62 29.201 13.4 30 10.5 30z" />
                        </svg></i> -->
                        <p style="margin-left: 8px;color:#000;" >
                          My Courses
                        </p>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a [routerLink]="['studentenroll']" class="nav-link" data-widget="pushmenu">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                          <path fill="black" d="M4 6H2v16h16v-2H4zm18-4H6v16h16zm-3 9H9V9h10zm-4 4H9v-2h6zm4-8H9V5h10z" />
                        </svg></i>
                        <p style="margin-left: 8px;color:black" >
                            Courses Enrollment Details                   
                          </p>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a [routerLink]="['mentorFeedback']" class="nav-link" data-widget="pushmenu">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
                          <path fill="black"
                            d="M19.95 15.89c.18.08.37.11.55.11c.41 0 .81-.17 1.1-.48L23.94 13H27c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3h-8c-1.65 0-3 1.35-3 3v4.99c0 1.65 1.35 3 3 3v1.5c0 .63.37 1.17.95 1.4M10.5 18c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m0 11.99c-2.9 0-5.12-.8-6.62-2.368c-1.931-2.015-1.886-4.585-1.881-4.838v-.017C2 21.26 3.26 20 4.82 20h11.36c1.55 0 2.82 1.259 2.82 2.817v.01c.004.182.06 2.77-1.88 4.805C15.62 29.201 13.4 30 10.5 30z" />
                        </svg></i>
                        <p style="margin-left: 8px;color:#000;" >
                          Mentor Feedback
                        </p>
                      </a>
                    </li>
                      </ul>
                  </li>
                    <!-- <li class="nav-item">
                      <a [routerLink]="['mentor-session']" class="nav-link">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256">
                          <path fill="black"
                            d="m231.65 194.55l-33.19-157.8a16 16 0 0 0-19-12.39l-46.81 10.06a16.08 16.08 0 0 0-12.3 19l33.19 157.8A16 16 0 0 0 169.16 224a16.25 16.25 0 0 0 3.38-.36l46.81-10.06a16.09 16.09 0 0 0 12.3-19.03M136 50.15v-.09l46.8-10l3.33 15.87L139.33 66Zm10 47.38l-3.35-15.9l46.82-10.06l3.34 15.9Zm70 100.41l-46.8 10l-3.33-15.87l46.8-10.07l3.33 15.85zM104 32H56a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h48a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16M56 48h48v16H56Zm48 160H56v-16h48z" />
                        </svg></i>
                        <p style="margin-left: 8px;color:black" >
                         Session Volunteer
                        </p>
                      </a>
                    </li> -->
                    <!-- <li class="nav-item">
                      <a [routerLink]="['courseAssignedMentor']" class="nav-link" data-widget="pushmenu">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                          <path fill="black" d="M4 6H2v16h16v-2H4zm18-4H6v16h16zm-3 9H9V9h10zm-4 4H9v-2h6zm4-8H9V5h10z" />
                        </svg></i>
                        <p style="margin-left: 8px;color:black" >
                          Course Assigned
                        </p>
                      </a>
                    </li> -->
                    <!-- <li class="nav-item"> -->
                      <!-- <div class="nav-link" (click)="this.showFeedback()" style="cursor: pointer;">
                        <i>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                            <path fill="black" d="M4 6H2v16h16v-2H4zm18-4H6v16h16zm-3 9H9V9h10zm-4 4H9v-2h6zm4-8H9V5h10z" />
                          </svg>
                        </i>
                          <p style="margin-left: 8px; color: black;">Feedback</p>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" [style.transform]="showCourse ? 'rotate(180deg)' : 'rotate(0deg)'"
                             [style.transition]="'transform 0.3s ease'" style="margin-left: auto;">
                          <path fill="black" d="M7 10l5 5 5-5z"/>
                        </svg>
                      </div> -->
                      <!-- <ul *ngIf="showFeedBack">
                        <li class="nav-item">
                          <a [routerLink]="['mentorFeedback']" class="nav-link" data-widget="pushmenu">
                            <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
                              <path fill="black"
                                d="M19.95 15.89c.18.08.37.11.55.11c.41 0 .81-.17 1.1-.48L23.94 13H27c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3h-8c-1.65 0-3 1.35-3 3v4.99c0 1.65 1.35 3 3 3v1.5c0 .63.37 1.17.95 1.4M10.5 18c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m0 11.99c-2.9 0-5.12-.8-6.62-2.368c-1.931-2.015-1.886-4.585-1.881-4.838v-.017C2 21.26 3.26 20 4.82 20h11.36c1.55 0 2.82 1.259 2.82 2.817v.01c.004.182.06 2.77-1.88 4.805C15.62 29.201 13.4 30 10.5 30z" />
                            </svg></i>
                            <p style="margin-left: 8px;color:#000;" >
                              Mentor Feedback
                            </p>
                          </a>
                        </li>
                      </ul> -->
                    <!-- <li class="nav-item">
                      <a [routerLink]="['mentor-volunteer']" class="nav-link" data-widget="pushmenu">
                        <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
                          <path fill="black"
                            d="M19.95 15.89c.18.08.37.11.55.11c.41 0 .81-.17 1.1-.48L23.94 13H27c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3h-8c-1.65 0-3 1.35-3 3v4.99c0 1.65 1.35 3 3 3v1.5c0 .63.37 1.17.95 1.4M10.5 18c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m0 11.99c-2.9 0-5.12-.8-6.62-2.368c-1.931-2.015-1.886-4.585-1.881-4.838v-.017C2 21.26 3.26 20 4.82 20h11.36c1.55 0 2.82 1.259 2.82 2.817v.01c.004.182.06 2.77-1.88 4.805C15.62 29.201 13.4 30 10.5 30z" />
                        </svg></i>
                        <p style="margin-left: 8px;color:#000;" >
                          Volunteering
                        </p>
                      </a>
                    </li> -->
                    <!-- <li class="nav-item">
                      <a [routerLink]="['mentorstudentrequest']" class="nav-link" data-widget="pushmenu">
                        <i class="fas fa-user-graduate" style="color: #000; font-weight: 900; font-size: 15px;"></i> -->
                        <!-- <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
                          <path fill="black"
                            d="M19.95 15.89c.18.08.37.11.55.11c.41 0 .81-.17 1.1-.48L23.94 13H27c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3h-8c-1.65 0-3 1.35-3 3v4.99c0 1.65 1.35 3 3 3v1.5c0 .63.37 1.17.95 1.4M10.5 18c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5m0 11.99c-2.9 0-5.12-.8-6.62-2.368c-1.931-2.015-1.886-4.585-1.881-4.838v-.017C2 21.26 3.26 20 4.82 20h11.36c1.55 0 2.82 1.259 2.82 2.817v.01c.004.182.06 2.77-1.88 4.805C15.62 29.201 13.4 30 10.5 30z" />
                        </svg></i> -->
                        <!-- <p style="margin-left: 8px;color:#000;" >
                          Student Request
                        </p>
                      </a>
                    </li> -->
                    <li class="nav-item">
                        <a [routerLink]="['mtchangePassword']" class="nav-link" data-widget="pushmenu">
                            <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                              <path fill="black"
                                d="M12 17a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2zm-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3" />
                            </svg></i>
                            <p style="margin-left: 8px;color:#000;" >
                                Change Password
                            </p>
                        </a>
                    </li>
                    <li class="nav-item" style="cursor: pointer;">
                      <a  [routerLink]="" class="nav-link" (click)="mentorDeleted()" data-widget="pushmenu">
                        <i class="">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"  viewBox="0 0 16 16">
                            <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                            <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708"/>
                          </svg>
                        </i>
                          <p style="margin-left: 8px;color:#000;" >
                            Close Account
                          </p>
                      </a>
                 </li>
                  

                    <li class="nav-item">
                        <a class="nav-link">
                            <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                              <path fill="black"
                                d="M4 12a1 1 0 0 0 1 1h7.59l-2.3 2.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33a1 1 0 0 0 0-.76a1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H5a1 1 0 0 0-1 1M17 2H7a3 3 0 0 0-3 3v3a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3" />
                            </svg></i>
                            <p style="margin-left: 8px;color:#000;" (click)="signout()" >
                                Sign Out
                            </p>
                        </a>
                    </li>

                </ul>

            </nav>
            <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
    </aside>

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <!--  -->
        <!-- /.content-header -->
<div style="min-height: 600px;">
        <router-outlet></router-outlet>
      </div>
      <div class="container disclaimer">
        <div class="row">
            <div class="col-lg-12 col-12">
                <strong>DISCLAIMER:</strong>
            </div>
            <div class="col-lg-12 col-12 paragraph ">
                <ul>
                    <li>This service is provided free of charge by the DMK Engineering Wing for students of Tamil Nadu.</li>
                    <li>Personal details, such as photos or addresses, should not be shared, except for WhatsApp contact information.</li>
                    <li>No fees should be collected under any circumstances.</li>
                    <li>The course can be modified / canceled at any time.</li>
                </ul>
            </div>
        </div>
    </div>
    
  
    <div class="footer">
      <div class="text-center p-3">
        <p>Copyright © MyRoots. Developed by <a  target="_blank"><strong>RedMind Technologies</strong></a> {{footerdate}}</p>
        <p>
          <i class="fa fa-phone" style="font-size:16px"></i>
          <strong> 7200749261</strong>
        </p>
      </div>
    </div>
    </div>
    <!-- /.content-wrapper -->
    <!-- <footer class="main-footer">
      <strong>Copyright &copy; 2014-2021 <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
      All rights reserved.
      <div class="float-right d-none d-sm-inline-block">
        <b>Version</b> 3.2.0
      </div>
    </footer> -->

    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
        <!-- Control sidebar content goes here -->
    </aside>
    <!-- /.control-sidebar -->
</div>